import React from "react";
import QrCode from "./Qrcode";



const Wifi = () => {


    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/wifi-blue.png" alt="wifi" className="icon wifi-icon" />
                <span>Wi-Fi(STA/AP)</span>
            </div>
            <div className="table-box">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>STA</th>
                            <th>AP</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>wlan0: 192.168.12.4</p>
                                <p>ssid: OfficeAir-2</p>
                                <p>ping: OK</p>
                            </td>
                            <td>
                                <QrCode showDetails={true} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                {/* <div className="col-md-12">
                    <div className="box-wrapper failed-wrapper">
                        <span>Wi-Fi(STA/AP)の接続を確認できません。</span>
                        <div className="two-button-box">
                            <button className="retry">リトライ</button>
                            <button className="skip">スキップ</button>
                        </div>
                    </div>
                </div> */}
            </div>
        </div >


    );
};

export default Wifi;